module.exports = __webpack_public_path__ + "media/icons/lightbulb-19c4352c.png";